import { defineStore } from 'pinia';


export const errors = defineStore('errors', {
    state: () => ({
        has_error: <boolean>false,
        messages: <Array<string>>[],
    }),
    getters: {
        get_has_errors(): Boolean {
            return this.has_error;
        },
        get_messages(): Array<string> {
            return this.messages;
        }
    },
    actions: {
        set_has_errors(status: boolean) {
            this.has_error = status
        },
        set_messages(message: string) {
            this.messages.push(message)
        },
        delete_messages() {
            this.messages = [];
        }
    }
});
